import { Component } from 'react';
import { Row, Col, Select, Button, Typography, Divider } from 'antd';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import MultiMarkerMap from '../../components/multiMarkerMap/MultiMarkerMap';
import { getMapCustomers } from '../../services/customer';
import { getMyBranches } from '../../services/api';
import { getRouteByBranch } from '../../services/route';
import { SearchOutlined } from '@ant-design/icons';

const { Option } = Select;
const { Text } = Typography;

class MapView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedBranchId: undefined,
            selectedRouteId: undefined, 
            customers: [],
            dataLoading: false,
            branchChoices: [],
            routeChoices: []
        }
        this.getBranchChoices = this.getBranchChoices.bind(this)
        this.getRouteChoices = this.getRouteChoices.bind(this)
        this.getCustomers = this.getCustomers.bind(this)
    }

    async getBranchChoices() {
        const res = await getMyBranches()
        const branchChoices = res.data.user_branches.map(ub => ub.branch)
        this.setState({
            branchChoices
        })
    }
    async getRouteChoices(branchId) {
        // set selected branch
        const { branchChoices } = this.state
        let branch;
        for (let i=0; i<branchChoices.length; i++){
            if (branchChoices[i].id === branchId){
                branch = branchChoices[i]
            }
        }
        this.setState({
            selectedBranchId: branchId,
            selectedBranch: branch
        }, async () => {
            const res = await getRouteByBranch([branchId])
            this.setState({
                routeChoices: res.data.routes,
                selectedRouteId: undefined
            })
        })
        
    }
    async getCustomers() {
        this.setState({
            dataLoading: true
        }, async () => {
            const { selectedBranchId, selectedRouteId } = this.state
            let result = await getMapCustomers(selectedBranchId, selectedRouteId)
            this.setState({
                customers: result.data.customers,
                total: result.data.total,
                dataLoading: false
            }, () => {
                const plotMarkers = this.googleMap.plotMarkers
                plotMarkers()
            })
        })
    }
    async componentDidMount() {
        const { profile } = this.props
        await this.getBranchChoices()
        await this.setState({
            selectedBranchId: profile.profile.current_branch.id
        })
        await this.getRouteChoices(profile.profile.current_branch.id)
    }

    render() {
        const { customers, selectedBranchId, selectedRouteId, branchChoices, routeChoices, selectedBranch } = this.state
        const { profile } = this.props
        return <div>
                <Divider orientation="center">แผนที่ร้านค้า</Divider>
                <Row>
                    {profile.profile.role === "ADMIN" ? 
                        <>
                            <Col span={2}></Col>
                            <Col span={8}>
                                <Select
                                    allowClear
                                    value={selectedBranchId}
                                    style={{ width: '100%', marginBottom: 10 }}
                                    placeholder="เลือกสาขา"
                                    optionFilterProp="children"
                                    onSelect={e => this.getRouteChoices(e)}
                                    onClear={e => this.setState({selectedRouteId: undefined, selectedBranchId: undefined})}
                                >
                                    {branchChoices.map(bc =>
                                        <Option key={bc.id} value={bc.id}>{bc.code} {bc.name}</Option>
                                    )}
                                </Select>
                            </Col>
                            <Col span={2}></Col>
                            <Col span={8}>
                                <Select
                                    allowClear
                                    value={selectedRouteId}
                                    style={{ width: '100%', marginBottom: 10 }}
                                    placeholder="เลือกสายบริการ"
                                    optionFilterProp="children"
                                    onSelect={e => this.setState({selectedRouteId: e})}
                                    onClear={e => this.setState({selectedRouteId: undefined})}
                                    disabled={selectedBranchId === undefined}
                                >
                                    {routeChoices.map(rc =>
                                        <Option key={rc.id} value={rc.id}>{rc.name}</Option>
                                    )}
                                </Select>
                            </Col>
                            <Col span={2}></Col>
                        </> :
                            <>
                                <Col span={6}></Col>
                                <Col span={10}>
                                    <Select
                                        allowClear
                                        value={selectedRouteId}
                                        style={{ width: '100%', marginBottom: 10 }}
                                        placeholder="เลือกสายบริการ"
                                        optionFilterProp="children"
                                        onSelect={e => this.setState({selectedRouteId: e})}
                                        onClear={e => this.setState({selectedRouteId: undefined})}
                                        disabled={selectedBranchId === undefined}
                                    >
                                        {routeChoices.map(rc =>
                                            <Option key={rc.id} value={rc.id}>{rc.name}</Option>
                                        )}
                                    </Select>
                                </Col>
                                <Col span={6}></Col>
                            </>
                    }
                    <Col span={2}>
                        <Button
                            style={{ float: 'right' }}
                            type="primary"
                            icon={<SearchOutlined />}
                            onClick={() => this.getCustomers()}
                            disabled={selectedRouteId === undefined}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        { selectedRouteId !== undefined && <MultiMarkerMap branch={selectedBranch} customers={customers} onRef={ref => (this.googleMap = ref)}/>}
                    </Col>
                    {/* {customers.length === 0 && <div className="center-container">
                        <SearchOutlined style={{fontSize: 40, color: 'rgba(0, 0, 0, 0.45)'}}/>
                        <Text type="secondary" style={{fontSize: 20}}>ไม่พบข้อมูล</Text>
                        <Text type="secondary" style={{fontSize: 20}}>กรุณาค้นหาใหม่อีกครั้ง</Text>
                    </div>} */}
                </Row>
        </div>
    }
}

function mapStateToProps(state) {
    return {
        profile: state.profile
    };
}

export default withRouter((connect(mapStateToProps)(MapView)));
